function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { DummyInput as DummyInputStyle } from './Dropdown.style';
export var DummyInput = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(DummyInputStyle, _extends({}, props, {
  ref: ref,
  tabIndex: 0,
  autoCorrect: "off",
  autoComplete: "off",
  autoCapitalize: "none",
  spellCheck: "false"
})));
//# sourceMappingURL=DummyInput.js.map